import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Styledfact from './Fact.style.js';

const Fact = ({
  content,
  fact
}) => /*#__PURE__*/React$1.createElement(Styledfact, {
  reveal: true,
  className: "fact__text",
  content: `${content}<div class="fact__content">${fact}</div>`,
  hasGrid: true
});

Fact.propTypes = {
  content: PropTypes$1.string.isRequired,
  fact: PropTypes$1.string.isRequired
};

export default Fact;
